import { OrderModel } from 'modules/Orders/models/order.model';
import { getOrderSetAmount } from 'modules/Orders/utils/getOrderSetAmount';

export const getOrderSumWithoutDiscount: (order: OrderModel) => number = order => {
  const deliveryCost = order.deliveryAddress.deliveryCost || 0;
  const allSetsAmount = order.basket.sets.reduce((sum, set) => sum + getOrderSetAmount(set), 0);

  return deliveryCost + allSetsAmount;
};
